import RouteView from '@/router/RouteView.vue';
import ClassLog from './index.vue';
import Detail from '../Statistical/StatisticalClass.vue';

export default [
  {
    path: '/classlog',
    name: 'Classlog',
    component: RouteView,
    redirect: '/classlog/list',
    meta: {
      title: '上课日志'
    },
    children: [
      {
        path: '/classlog/list',
        name: 'ClassLogList',
        component: ClassLog,
        meta: {
          title: '日志列表'
        },
      },
      {
        path: '/classlog/detail/:id',
        name: 'ClassLogDetail',
        component: Detail,
        meta: {
          title: '日志详情'
        },
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/views/ClassLog/index.js